module.exports = __webpack_public_path__ + "static/img/workertechsupport.8b6804b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workertechsupport.jpeg
// module id = CbIh
// module chunks = 62